<template>
    <div>
        <Breadcrumb section-name="Shareholder" :breadcrumb="breadCrumb" :btn-name="'Add '+ breadCrumb"
                    :click-action="shareholderAdd"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <Table :tbl-data="table" :param="param"></Table>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Table from "../Common/Table";
import DownloadService from "../../Services/DownloadService";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue";
export default {
    components: {Table, Breadcrumb, ConfirmDialogue},
    data() {
        return {
            breadCrumb: [],
            param: {
                keyword: '',
                limit: 10,
                order_by: 'id',
                order_mode: 'DESC',
                page: 1,
            },
            table: {
                columns: [
                    {type: 'text', key: 'id_number', label: 'ID', sortable: true},
                    {type: 'text', key: 'name', label: 'Name', photo: true, sortable: true},
                    {type: 'text', key: 'type', label: 'Type', sortable: true},
                    {type: 'text', key: 'district_name', label: 'District', sortable: true},
                    {type: 'text', key: 'area_name', label: 'Area', sortable: true},
                    {type: 'text', key: 'mobile_number', label: 'Mobile Number', sortable: true},
                ],
                rows: [],
                row_actions: [
                    {name: 'view', type: 'action', label: 'bx bx-search-alt', color: 'btn-gradient-primary'},
                    {name: 'basicInfo', type: 'action', label: 'bx bx-search-alt', color: 'btn-gradient-info'},
                    {name: 'print', type: 'action', label: 'bx bx-printer', color: 'btn-gradient-info',  loading: false},
                    {name: 'edit', type: 'action', label: 'bx bx-pencil', color: 'btn-info'},
                    {name: 'delete', type: 'action', label: 'bx bx-trash', color: 'btn-gradient-danger'}
                ],
                tableIconAction: (data) => {
                    this.tableIconAction(data.row_action, data.row_data, data.row_index);
                },
                tableLoading: false,
                paginateData: {},
                updatePagination: (page) => {
                    this.list(page)
                },
                updateFilter: (param) => {
                    this.param = param
                    this.list()
                },
                dropdown: [

                ],
                download: [
                    {
                        icon: 'xls',
                        loading: false,
                        action: () => {
                            this.downloadFile('xls')
                        }
                    },
                    {
                        icon: 'pdf',
                        loading: false,
                        action: () => {
                            this.downloadFile('pdf')
                        }
                    }
                ],
                noDataError: ' Please click "+ Add Shareholder" to add a new Shareholder'
            },
            id: []
        }
    },
    watch: {

    },
    methods: {
        shareholderAdd() {
            this.$router.push({
                name: 'shareholderAdd'
            })
        },
        async tableIconAction (type, data, index = null) {
            this.id = this.structureReturnData(data)
            if (type === 'edit') {
               const url = this.$router.resolve({
                    name: 'shareholderEdit',
                    params: { id: data.id }
                }).href
                window.open(url, '_blank')
            } else if (type === 'view') {
                this.$router.push({
                    name: 'shareholderView',
                    params: { id: data.id }
                })
            } else if (type === 'basicInfo') {
                this.$router.push({
                    name: 'shareholderBasicInfo',
                    params: { id: data.id }
                })
            } else if (type === 'print') {
                PrintService.print('/print/shareholder/' + data.id);
            } else if (type === 'delete') {
                const ok = await this.$refs.confirmDialogue.show({
                    title: 'Delete Shareholder',
                    message: 'Are you sure you want to delete this Shareholder?',
                    okButton: 'Delete',
                })
                if (ok) {
                    this.delete()
                }
            } else if (type === 'pdf') {
                if (index != null) {
                    $('.'+index).toggle()
                    ApiService.DOWNLOAD(ApiRoutes.EmployeeSingleExportPdf, {id: data.id},'',res => {
                        $('.'+index).toggle()
                        let blob = new Blob([res], {type: type});
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = data.name+'.pdf';
                        link.click();
                    });
                }
            }
        },

        list: function (page) {
            if (page === undefined) {
                page = 1
            }
            this.param.page = page;
            this.table.loading = true
            ApiService.POST(ApiRoutes.ShareHolder + '/list', this.param, (res) => {
                this.table.loading = false
                if (parseInt(res.status) === 200) {
                    this.table.rows = res.data.data
                    this.table.paginateData = res.data
                }
            });
        },
        delete: function () {
            ApiService.POST(ApiRoutes.ShareHolder + '/delete', {id: this.id[0]}, (res) => {
                this.$refs.confirmDialogue._loading(false)
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    this.$refs.confirmDialogue._hide()
                    this.list()
                }
            });
        },
        downloadFile: function (type) {
            let route = type === 'xls' ? ApiRoutes.EmployeeExportExcel : ApiRoutes.EmployeeExportPdf
            let name = type === 'xls' ? 'Employee List.xlsx' : 'Employee List.pdf'
            DownloadService.download(route, this.table.download, name, type, this.param)
        }
    },
    mounted() {
        this.list()
    },
    created() {
        this.breadCrumb.push(this.$route.name)
    }
}
</script>

<style scoped>

</style>
